import type { AppBuildDTO } from "@/entities/app-build/@x/app-device";
import type { AppDeviceSessionStatus } from "@/entities/app-device/model/types";
import { isWithin7Days } from "@/shared/lib/isWithin7Days";

export const APP_DEVICE_STEPS = ["boot", "install", "open"] as const;

type AppDeviceStep = (typeof APP_DEVICE_STEPS)[number];

// Mesmas regras do BE: só o APK de staging do Worker, concluído e ainda na VPS.
export function canOpenOnAppDevice(build: AppBuildDTO): boolean {
  return (
    build.app === "WORKER" &&
    build.status === "SUCCESS" &&
    build.environment === "STAGING" &&
    build.format === "APK" &&
    Boolean(build.downloadUrl) &&
    isWithin7Days(build.createdAt)
  );
}

export function isSafeStreamUrl(url: string): boolean {
  try {
    return new URL(url).protocol === "https:";
  } catch {
    return false;
  }
}

// WebCodecs decodifica o vídeo no hardware do navegador; sem ele o ws-scrcpy cai no Broadway, em JavaScript.
export function embedStreamUrl(streamUrl: string, supportsWebCodecs: boolean): string {
  const url = new URL(streamUrl);
  const params = new URLSearchParams(url.hash.replace(/^#!?/, ""));
  params.set("player", supportsWebCodecs ? "webcodecs" : "broadway");
  // Com fitToScreen o ws-scrcpy pede ao Android um vídeo do tamanho do iframe em px CSS (chegava 224x416).
  // Desligado, o vídeo vem na resolução cheia e o CSS só redimensiona; o "0" explícito vence a preferência salva.
  params.set("fitToScreen", "0");
  url.hash = `!${params.toString()}`;
  return url.toString();
}

export function browserSupportsWebCodecs(): boolean {
  return typeof window !== "undefined" && "VideoDecoder" in window;
}

export function formatRemaining(ms: number): string {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

export function currentStepIndex(status: AppDeviceSessionStatus): number {
  switch (status) {
    case "STARTING":
    case "BOOTING":
      return 0;
    case "INSTALLING":
      return 1;
    default:
      return 2;
  }
}
